/**
 * @file artworksBreakpoints.config.ts
 * @description This file exports several constants and types related to the configuration of artwork breakpoints.
 */

import { ArtworkResolutions, ImageResolution } from '@/common/components/ArtworkPicture/artworkUri';
import { screenSizes } from '@/common/hooks/useResponsive/useResponsive';

export interface ArtworkBreakPointConfig {
  [key: number]: {
    x1: ImageResolution;
    x2: ImageResolution;
  };
}

/**
 * @constant visArtworkSets
 * @description This is an object of type `ArtworkBreakPointConfig` that maps viewport sizes to arrays of image resolutions for visual artworks.
 */
const visArtworkSets: ArtworkBreakPointConfig = {
  [screenSizes.xs]: {
    x1: ArtworkResolutions.rect.rect320x230,
    x2: ArtworkResolutions.rect.rect640x460,
  },
  [screenSizes.md]: {
    x1: ArtworkResolutions.rect.rect454x324,
    x2: ArtworkResolutions.rect.rect784x560,
  },
  [screenSizes.lg]: {
    x1: ArtworkResolutions.rect.rect320x230,
    x2: ArtworkResolutions.rect.rect640x460,
  },
  [screenSizes.xl2]: {
    x1: ArtworkResolutions.rect.rect454x324,
    x2: ArtworkResolutions.rect.rect784x560,
  },
  [screenSizes.xl3]: {
    x1: ArtworkResolutions.rect.rect640x460,
    x2: ArtworkResolutions.rect.rect1200x857,
  },
};

/**
 * @constant mansonryArtworkSets
 * @description This is an object of type `ArtworkBreakPointConfig` that maps viewport sizes to arrays of image resolutions for artworks in a masonry layout.
 */
const mansonryArtworkSets: ArtworkBreakPointConfig = {
  [screenSizes.xs]: {
    x1: ArtworkResolutions.rect.rect227x162,
    x2: ArtworkResolutions.rect.rect454x324,
  },
  [screenSizes.xl]: {
    x1: ArtworkResolutions.rect.rect320x230,
    x2: ArtworkResolutions.rect.rect640x460,
  },
  [screenSizes.xl2]: {
    x1: ArtworkResolutions.rect.rect454x324,
    x2: ArtworkResolutions.rect.rect784x560,
  },
};

export { visArtworkSets, mansonryArtworkSets };
